/* eslint-disable max-len */
import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PmsPreference } from '@ffd/api-client';
import { routes } from '@libs/utils';
import { TooltipModule } from '@libs/ui-lib';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from 'ngx-markdown';
import { TagEvent, TagPusherService } from '@libs/shared-services';
import { SiteSetupNavbarComponent } from '../../site-setup/components/site-setup-navbar/site-setup-navbar.component';
import { SiteSetupComponentService, StepNumberEnum } from '../../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-server-installation-checklist',
  imports: [CommonModule, SiteSetupNavbarComponent, TranslateModule, MarkdownPipe, TooltipModule],
  templateUrl: './server-installation-checklist.component.html',
  styleUrl: './server-installation-checklist.component.scss',
})
export class ServerInstallationCheckListComponent {
  private readonly service = inject(SiteSetupComponentService);
  private readonly router = inject(Router);
  private readonly tagPusherService = inject(TagPusherService);

  public vm = this.service.viewModel;

  // PmsPreference values are already display names ("Dentrix", "Open Dental"), so they go straight into the copy.
  // "Other" and "No PMS" carry no usable name, so those practices get the generic wording instead.
  public pmsName = computed(() => {
    const selectedPms = this.vm().siteInstallRequirements?.data?.selectedPms;

    return selectedPms && selectedPms !== PmsPreference.OTHER && selectedPms !== PmsPreference.NO_PMS ? selectedPms : '';
  });

  public routes = routes;
  public StepNumberEnum = StepNumberEnum;

  public comeBackLater(): void {
    this.service.abandonContract();
  }

  public ready(): void {
    this.tagPusherService.pushTag({
      event: TagEvent.ServerInstallationStarted,
      contract_id: this.vm().contract?.data?.id,
    });

    this.service.setContractActiveStep({
      step: StepNumberEnum.ServerInstallationDownload,
    });
    this.service.setActiveStep(StepNumberEnum.ServerInstallationDownload);
    this.router.navigate([routes.setup, routes.serverInstallation, routes.download]);
  }
}
